import { CALL_API, isRSAA } from 'redux-api-middleware';


const authMiddleware = ({ getState }) => {
	return (next) => (action) => {
		if (!isRSAA(action)) {
			return next(action);
		}
		const state = getState();
		const callAPI = action[CALL_API];
		let { headers } = callAPI;

		headers = headers || {};
		if (state.app.token) {
			headers['Authorization'] = `{state.app.token}`;
		}
		callAPI.headers = headers;
		next(action);
	}
}

export default authMiddleware;



// WEBPACK FOOTER //
// ./src/stores/authMiddleware.js